import mapActions from './mapActions';

export default mapActions('material_categories', {
    fetchAll_url: () => '/api/material_items/categories',
});